import RentalListPage from "../common/Rentals/RentalListPage";
import SmartLockMonitoringModal from "../common/Rentals/SmartLockMonitoringModal";
import AddUnit from "./add";
import TableRow from "./row";

const UNITS_CONFIG = {
  pageTitle: "Units",
  addButtonLabel: "Unit",
  emptyMessage: "No units matching your current search or filters.",
  sortOptions: ["updated_at", "pms_id"],
  hasFilters: false,
  extraButtons: [
    { label: "Property Field Values", href: "/property-field-values" }
  ],
  ShowShareComponent: false,
  ShowMonitoringComponent: true,
  AddComponent: AddUnit,
  RowComponent: TableRow,
  MonitoringComponent: SmartLockMonitoringModal,
};

export default () => <RentalListPage config={UNITS_CONFIG} />;